import OIDCIcon from 'components/core/icons/oidc.svg'
import Image from 'components/core/image'

const OIDC = (): React.ReactElement => {
    return <Image src={OIDCIcon.src} height={24} width={24} />
}

export default OIDC
